export {
  GetStartedButton,
  type GetStartedButtonProps,
} from './GetStartedButton';
